import "./recommendations.scss"

export default function Recommendations() {
  return (
    <div className="recommended" id="recommended">
        <h1><b>Recommended Reminders</b></h1>
        <h2>Set a Reminder to:</h2>
        <ul>
          <li>Workout</li>
              <li>Go to sleep on time</li>
              <li>Do your homework</li>
              <li>Drink water</li>
              <li>Schedule an appointment</li>
            </ul>
      <a href="#contact">
           <img src="assets/down3.png" alt="" />
           </a>
    </div>
  )
}
